import React from 'react';
import PropTypes, { any } from 'prop-types';
import Img from '../../../../Img';
import AvatarV2 from '../../../../cards/PlayerCard/ListViewComponents/AvatarV2';
import useIsMobile from '../../../../hooks/useIsMobile';

import styles from '../../localizedRankings.scss';

const ResultCard = ({ player, isProfilePlayer, isPowerUser }) => {
    const { ratingDisplay, rank, playerId, firstName, lastName, location, playerProfileImages } = player || {};
    const { isMobileWidth } = useIsMobile();
    let resultCardClassName = isProfilePlayer ? styles.currentUserResultCard : styles.resultCard;
    if (!isPowerUser && !isProfilePlayer) {
        resultCardClassName = styles.resultCardBlurred;
    }

    return (
        <div className={resultCardClassName}>
            <div className={styles.resultCardContent}>
                <div className={styles.playerInfoContainer}>
                    <AvatarV2 player={player} playerImages={playerProfileImages} />
                    <div className={styles.playerData}>
                        {isProfilePlayer ? (
                            <p className={styles.currentUserPlayerName}>{`${firstName} ${lastName}`}</p>
                        ) : (
                            <a href={`/profiles/${playerId}`} className={styles.playerName}>{`${firstName} ${lastName}`}</a>
                        )}
                        {isMobileWidth ? (
                            <>
                                <div className={styles.playerRatingContainer}>
                                    <p className={styles.playerRating}>{`UTR ${ratingDisplay}`}</p>
                                    <Img src="/img/v4/icon-verified-checkmark-black.svg" alt="Verified" />
                                </div>
                                {location && (
                                    <p className={styles.playerLocation}>{location}</p>
                                )}
                            </>
                        ) : (
                            <div className={styles.playerRatingContainer}>
                                <p className={styles.playerRating}>{`UTR ${ratingDisplay}`}</p>
                                <Img src="/img/v4/icon-verified-checkmark-black.svg" alt="Verified" />
                                {location && (
                                    <p className={styles.playerLocation}>{`\u2022 ${location}`}</p>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {isPowerUser ? (
                    <p className={styles.playerRank}>{rank?.toLocaleString()}</p>
                ) : (
                    <Img src="/img/v2/icons/icon-feature-lock.svg" alt="Locked" />
                )}
            </div>
        </div>
    );
};

ResultCard.propTypes = {
    player: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        playerProfileImages: PropTypes.objectOf(any),
        ratingDisplay: PropTypes.string.isRequired,
        rank: PropTypes.number,
        playerId: PropTypes.number.isRequired,
    }).isRequired,
    isProfilePlayer: PropTypes.bool.isRequired,
    isPowerUser: PropTypes.bool.isRequired,
};

export default ResultCard;
